//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';

import FETCHING from  '../../library/fetching'


 

export default {
    data () {
      return {
          FETCHING: FETCHING,
          token : localStorage.token,  
          terbitkanSurat:false, 
          modal_y:false,
          modal_n:false,

          lihat_blue:false,
          lihat_red:false,

          option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],


            form: { 
              file_lampiran     :null,
              file_lampiranOld  :null,

              modul:'sk_kelahiran',

              m_provinsi : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '', 

              nama_kepala_keluarga: '',
              no_kk: '',

              nama_bayi: '',
              jenis_kelamin_bayi: '',

              tmpt_lahir_bayi:'',
              tmpt_lahir_bayi_lainnya: '',

              tempat_kelahiran_bayi:'',

              nama_hari:'',
              tgl_lahir_bayi:'',
              pukul:'',

              jenis_lahir:'',
              jenis_lahir_lainnya:'',

              kelahiran_ke:'',
              penolong_kelahiran:'',
              penolong_kelahiran_lainnya:'',

              berat_bayi:'',
              panjang_bayi:'',

              nik_ibu:'',
              nama_ibu:'',
              tgl_lahir_ibu:'',
              pekerjaan_ibu:'',

              provinsi_ibu:'',
              kabupaten_ibu:'',
              kecamatan_ibu:'',
              des_kel_ibu:'',
              alamat_ibu:'',
              kewarganegaraan_ibu:'',
              kewarganegaraan_ibu_lainnya:'',

              tgl_catatan_perkawinan:'',


              nik_ayah:'',
              nama_ayah:'',
              tgl_lahir_ayah:'',
              pekerjaan_ayah:'',

              provinsi_ayah:'',
              kabupaten_ayah:'',
              kecamatan_ayah:'',
              des_kel_ayah:'',
              alamat_ayah:'',
              kewarganegaraan_ayah:'',
              kewarganegaraan_ayah_lainnya:'',
              
              nik_pelapor:'',
              nama_pelapor:'',
              umur_pelapor:'',
              pekerjaan_pelapor:'',
              provinsi_pelapor:'',
              kabupaten_pelapor:'',
              kecamatan_pelapor:'',
              des_kel_pelapor:'',
              alamat_pelapor:'',
              
              nik_saksi1:'',
              nama_saksi1:'',
              umur_saksi1:'',
              pekerjaan_saksi1:'',
              provinsi_saksi1:'',
              kabupaten_saksi1:'',
              kecamatan_saksi1:'',
              des_kel_saksi1:'',
              alamat_saksi1:'',
              
              nik_saksi2:'',
              nama_saksi2:'',
              umur_saksi2:'',
              pekerjaan_saksi2:'',
              provinsi_saksi2:'',
              kabupaten_saksi2:'',
              kecamatan_saksi2:'',
              des_kel_saksi2:'',
              alamat_saksi2:'', 

              // keterangan_deskel:'', 
              // keterangan_kecamatan:'', 
              // keterangan_kabupaten:'',  

              status : 0,
              keterangan : 0,
              
              keterangan_deskel:'',
              keterangan_kecamatan:'',
              keterangan_kabupaten  :'',

              status_deskel:0,
              status_kecamatan:0,
              status_kabupaten  :0,
              
              createdAt_deskel:'',
              createdAt_kecamatan:'',
              createdAt_kabupaten  :'',


              file_terbitan : null,
              emailPemohon:'',

              email_file     :null,
              email_fileOld  :'',

              email_from     :'',
              email_to       :'',
              email_subject  :'',
              email_html     :'',

               

            
            },


            shape: '', 
            current: 3,  
            dense:true, 
            list_anggota_keluarga:[],
            data: null,

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahIbu : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahAyah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahPelapor : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahSaksi1 : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahSaksi2 : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },

            list_data : [],
            list_data_kecamatan : [],
            list_data_kabupaten : [],

            page_limit : 5,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,
            UMUM : UMUM,        
            WILAYAH : WILAYAH, 
     
     
      }
    },
    methods: {
      
      klik : function (){
        console.log("klik");
      },
    // ============================= USERS =============================      
      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;  
                // console.log(res_data);
        });
      },      
      validateForm: function() {
        const f = this.form;

        // ========== WILAYAH ADMINISTRASI ==========
        if (!f.m_provinsi || f.m_provinsi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi wilayah administrasi.' });
          return false;
        }
        if (!f.m_kabupaten || f.m_kabupaten === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten wilayah administrasi.' });
          return false;
        }
        if (!f.m_kecamatan || f.m_kecamatan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan wilayah administrasi.' });
          return false;
        }
        if (!f.m_desa_kelurahan || f.m_desa_kelurahan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan wilayah administrasi.' });
          return false;
        }

        // ========== KEPALA KELUARGA & KK ==========
        if (!f.nama_kepala_keluarga || f.nama_kepala_keluarga.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama kepala keluarga wajib diisi.' });
          return false;
        }
        if (!f.no_kk || f.no_kk.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nomor kartu keluarga wajib diisi.' });
          return false;
        }

        // ========== DATA BAYI ==========
        if (!f.nama_bayi || f.nama_bayi.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama bayi wajib diisi.' });
          return false;
        }
        if (!f.jenis_kelamin_bayi || f.jenis_kelamin_bayi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih jenis kelamin bayi.' });
          return false;
        }
        if (!f.tmpt_lahir_bayi || f.tmpt_lahir_bayi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih tempat dilahirkan bayi.' });
          return false;
        }
        if (f.tmpt_lahir_bayi === 'Lainnya' && (!f.tmpt_lahir_bayi_lainnya || f.tmpt_lahir_bayi_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi tempat dilahirkan lainnya.' });
          return false;
        }
        if (!f.tempat_kelahiran_bayi || f.tempat_kelahiran_bayi.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Tempat kelahiran bayi wajib diisi.' });
          return false;
        }
        if (!f.nama_hari || f.nama_hari === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih hari lahir bayi.' });
          return false;
        }
        if (!f.tgl_lahir_bayi || f.tgl_lahir_bayi === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal lahir bayi wajib diisi.' });
          return false;
        }
        if (!f.pukul || f.pukul === '') {
          this.$q.notify({ type: 'negative', message: 'Pukul kelahiran bayi wajib diisi.' });
          return false;
        }
        if (!f.jenis_lahir || f.jenis_lahir === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih jenis kelahiran.' });
          return false;
        }
        if (f.jenis_lahir === 'Lainnya' && (!f.jenis_lahir_lainnya || f.jenis_lahir_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi jenis kelahiran lainnya.' });
          return false;
        }
        if (f.kelahiran_ke === '' || f.kelahiran_ke === null || f.kelahiran_ke === undefined) {
          this.$q.notify({ type: 'negative', message: 'Kelahiran ke- wajib diisi.' });
          return false;
        }
        if (!f.penolong_kelahiran || f.penolong_kelahiran === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih penolong kelahiran.' });
          return false;
        }
        if (f.penolong_kelahiran === 'Lainnya' && (!f.penolong_kelahiran_lainnya || f.penolong_kelahiran_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi penolong kelahiran lainnya.' });
          return false;
        }
        if (f.berat_bayi === '' || f.berat_bayi === null || f.berat_bayi === undefined) {
          this.$q.notify({ type: 'negative', message: 'Berat bayi wajib diisi.' });
          return false;
        }
        if (f.panjang_bayi === '' || f.panjang_bayi === null || f.panjang_bayi === undefined) {
          this.$q.notify({ type: 'negative', message: 'Panjang bayi wajib diisi.' });
          return false;
        }

        // ========== DATA IBU ==========
        if (!f.nik_ibu || f.nik_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK ibu wajib diisi.' });
          return false;
        }
        if (!f.nama_ibu || f.nama_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama ibu wajib diisi.' });
          return false;
        }
        if (!f.tgl_lahir_ibu || f.tgl_lahir_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal lahir ibu wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_ibu || f.pekerjaan_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan ibu wajib diisi.' });
          return false;
        }
        if (!f.alamat_ibu || f.alamat_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat ibu wajib diisi.' });
          return false;
        }
        if (!f.kewarganegaraan_ibu || f.kewarganegaraan_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kewarganegaraan ibu.' });
          return false;
        }
        if (f.kewarganegaraan_ibu === 'Lainnya' && (!f.kewarganegaraan_ibu_lainnya || f.kewarganegaraan_ibu_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi kewarganegaraan ibu lainnya.' });
          return false;
        }
        if (!f.tgl_catatan_perkawinan || f.tgl_catatan_perkawinan === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal pencatatan perkawinan wajib diisi.' });
          return false;
        }
        if (!f.provinsi_ibu || f.provinsi_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat ibu.' });
          return false;
        }
        if (!f.kabupaten_ibu || f.kabupaten_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat ibu.' });
          return false;
        }
        if (!f.kecamatan_ibu || f.kecamatan_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat ibu.' });
          return false;
        }
        if (!f.des_kel_ibu || f.des_kel_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat ibu.' });
          return false;
        }

        // ========== DATA AYAH ==========
        if (!f.nik_ayah || f.nik_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK ayah wajib diisi.' });
          return false;
        }
        if (!f.nama_ayah || f.nama_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama ayah wajib diisi.' });
          return false;
        }
        if (!f.tgl_lahir_ayah || f.tgl_lahir_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal lahir ayah wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_ayah || f.pekerjaan_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan ayah wajib diisi.' });
          return false;
        }
        if (!f.alamat_ayah || f.alamat_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat ayah wajib diisi.' });
          return false;
        }
        if (!f.kewarganegaraan_ayah || f.kewarganegaraan_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kewarganegaraan ayah.' });
          return false;
        }
        if (f.kewarganegaraan_ayah === 'Lainnya' && (!f.kewarganegaraan_ayah_lainnya || f.kewarganegaraan_ayah_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi kewarganegaraan ayah lainnya.' });
          return false;
        }
        if (!f.provinsi_ayah || f.provinsi_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat ayah.' });
          return false;
        }
        if (!f.kabupaten_ayah || f.kabupaten_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat ayah.' });
          return false;
        }
        if (!f.kecamatan_ayah || f.kecamatan_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat ayah.' });
          return false;
        }
        if (!f.des_kel_ayah || f.des_kel_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat ayah.' });
          return false;
        }

        // ========== DATA PELAPOR ==========
        if (!f.nik_pelapor || f.nik_pelapor.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK pelapor wajib diisi.' });
          return false;
        }
        if (!f.nama_pelapor || f.nama_pelapor.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama pelapor wajib diisi.' });
          return false;
        }
        if (f.umur_pelapor === '' || f.umur_pelapor === null || f.umur_pelapor === undefined) {
          this.$q.notify({ type: 'negative', message: 'Umur pelapor wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_pelapor || f.pekerjaan_pelapor.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan pelapor wajib diisi.' });
          return false;
        }
        if (!f.alamat_pelapor || f.alamat_pelapor.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat pelapor wajib diisi.' });
          return false;
        }
        if (!f.provinsi_pelapor || f.provinsi_pelapor === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat pelapor.' });
          return false;
        }
        if (!f.kabupaten_pelapor || f.kabupaten_pelapor === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat pelapor.' });
          return false;
        }
        if (!f.kecamatan_pelapor || f.kecamatan_pelapor === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat pelapor.' });
          return false;
        }
        if (!f.des_kel_pelapor || f.des_kel_pelapor === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat pelapor.' });
          return false;
        }

        // ========== DATA SAKSI 1 ==========
        if (!f.nik_saksi1 || f.nik_saksi1.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK saksi 1 wajib diisi.' });
          return false;
        }
        if (!f.nama_saksi1 || f.nama_saksi1.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama saksi 1 wajib diisi.' });
          return false;
        }
        if (f.umur_saksi1 === '' || f.umur_saksi1 === null || f.umur_saksi1 === undefined) {
          this.$q.notify({ type: 'negative', message: 'Umur saksi 1 wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_saksi1 || f.pekerjaan_saksi1.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan saksi 1 wajib diisi.' });
          return false;
        }
        if (!f.alamat_saksi1 || f.alamat_saksi1.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat saksi 1 wajib diisi.' });
          return false;
        }
        if (!f.provinsi_saksi1 || f.provinsi_saksi1 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat saksi 1.' });
          return false;
        }
        if (!f.kabupaten_saksi1 || f.kabupaten_saksi1 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat saksi 1.' });
          return false;
        }
        if (!f.kecamatan_saksi1 || f.kecamatan_saksi1 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat saksi 1.' });
          return false;
        }
        if (!f.des_kel_saksi1 || f.des_kel_saksi1 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat saksi 1.' });
          return false;
        }

        // ========== DATA SAKSI 2 ==========
        if (!f.nik_saksi2 || f.nik_saksi2.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK saksi 2 wajib diisi.' });
          return false;
        }
        if (!f.nama_saksi2 || f.nama_saksi2.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama saksi 2 wajib diisi.' });
          return false;
        }
        if (f.umur_saksi2 === '' || f.umur_saksi2 === null || f.umur_saksi2 === undefined) {
          this.$q.notify({ type: 'negative', message: 'Umur saksi 2 wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_saksi2 || f.pekerjaan_saksi2.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan saksi 2 wajib diisi.' });
          return false;
        }
        if (!f.alamat_saksi2 || f.alamat_saksi2.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat saksi 2 wajib diisi.' });
          return false;
        }
        if (!f.provinsi_saksi2 || f.provinsi_saksi2 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat saksi 2.' });
          return false;
        }
        if (!f.kabupaten_saksi2 || f.kabupaten_saksi2 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat saksi 2.' });
          return false;
        }
        if (!f.kecamatan_saksi2 || f.kecamatan_saksi2 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat saksi 2.' });
          return false;
        }
        if (!f.des_kel_saksi2 || f.des_kel_saksi2 === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat saksi 2.' });
          return false;
        }

        // ========== LAMPIRAN FILE ==========
        if (!f.file_lampiran || f.file_lampiran === '') {
          this.$q.notify({ type: 'negative', message: 'File lampiran wajib diisi.' });
          return false;
        }

        return true;
      },
      add_data(){ 
        // Jalankan validasi seluruh form input
        if (!this.validateForm()) {
          return;
        }

        this.$store.state.modal_loading = true;


        var formData = new FormData(); 
        formData.append("modul", this.form.modul);  

        formData.append("id", uniqid());  

        formData.append("m_provinsi", this.form.m_provinsi);
        formData.append("m_kabupaten", this.form.m_kabupaten);
        formData.append("m_kecamatan", this.form.m_kecamatan);
        formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan); 

        formData.append("nama_kepala_keluarga", this.form.nama_kepala_keluarga);
        formData.append("no_kk", this.form.no_kk);
        formData.append("nama_bayi", this.form.nama_bayi);
        formData.append("jenis_kelamin_bayi", this.form.jenis_kelamin_bayi);

        formData.append("tempat_kelahiran_bayi", this.form.tempat_kelahiran_bayi);

        formData.append("tmpt_lahir_bayi", this.form.tmpt_lahir_bayi);
        formData.append("tmpt_lahir_bayi_lainnya", this.form.tmpt_lahir_bayi_lainnya);
        formData.append("nama_hari", this.form.nama_hari);
        formData.append("tgl_lahir_bayi", this.form.tgl_lahir_bayi);
        formData.append("pukul", this.form.pukul);
        formData.append("jenis_lahir", this.form.jenis_lahir);
        formData.append("jenis_lahir_lainnya", this.form.jenis_lahir_lainnya);
        formData.append("kelahiran_ke", this.form.kelahiran_ke);
        formData.append("penolong_kelahiran", this.form.penolong_kelahiran);
        formData.append("penolong_kelahiran_lainnya", this.form.penolong_kelahiran_lainnya);
        formData.append("berat_bayi", this.form.berat_bayi);
        formData.append("panjang_bayi", this.form.panjang_bayi);

        formData.append("nik_ibu", this.form.nik_ibu);
        formData.append("nama_ibu", this.form.nama_ibu);
        formData.append("tgl_lahir_ibu", this.form.tgl_lahir_ibu);
        formData.append("pekerjaan_ibu", this.form.pekerjaan_ibu);
        formData.append("provinsi_ibu", this.form.provinsi_ibu);
        formData.append("kabupaten_ibu", this.form.kabupaten_ibu);
        formData.append("kecamatan_ibu", this.form.kecamatan_ibu);
        formData.append("des_kel_ibu", this.form.des_kel_ibu);
        formData.append("alamat_ibu", this.form.alamat_ibu);
        formData.append("kewarganegaraan_ibu", this.form.kewarganegaraan_ibu);
        formData.append("kewarganegaraan_ibu_lainnya", this.form.kewarganegaraan_ibu_lainnya);
        formData.append("tgl_catatan_perkawinan", this.form.tgl_catatan_perkawinan);


        formData.append("nik_ayah", this.form.nik_ayah);
        formData.append("nama_ayah", this.form.nama_ayah);
        formData.append("tgl_lahir_ayah", this.form.tgl_lahir_ayah);
        formData.append("pekerjaan_ayah", this.form.pekerjaan_ayah);
        formData.append("provinsi_ayah", this.form.provinsi_ayah);
        formData.append("kabupaten_ayah", this.form.kabupaten_ayah);
        formData.append("kecamatan_ayah", this.form.kecamatan_ayah);
        formData.append("des_kel_ayah", this.form.des_kel_ayah);
        formData.append("alamat_ayah", this.form.alamat_ayah);
        formData.append("kewarganegaraan_ayah", this.form.kewarganegaraan_ayah);
        formData.append("kewarganegaraan_ayah_lainnya", this.form.kewarganegaraan_ayah_lainnya);

        formData.append("nik_pelapor", this.form.nik_pelapor);
        formData.append("nama_pelapor", this.form.nama_pelapor);
        formData.append("umur_pelapor", this.form.umur_pelapor);
        formData.append("pekerjaan_pelapor", this.form.pekerjaan_pelapor);
        formData.append("provinsi_pelapor", this.form.provinsi_pelapor);
        formData.append("kabupaten_pelapor", this.form.kabupaten_pelapor);
        formData.append("kecamatan_pelapor", this.form.kecamatan_pelapor);
        formData.append("des_kel_pelapor", this.form.des_kel_pelapor);
        formData.append("alamat_pelapor", this.form.alamat_pelapor);

        formData.append("nik_saksi1", this.form.nik_saksi1);
        formData.append("nama_saksi1", this.form.nama_saksi1);
        formData.append("umur_saksi1", this.form.umur_saksi1);
        formData.append("pekerjaan_saksi1", this.form.pekerjaan_saksi1);
        formData.append("provinsi_saksi1", this.form.provinsi_saksi1);
        formData.append("kabupaten_saksi1", this.form.kabupaten_saksi1);
        formData.append("kecamatan_saksi1", this.form.kecamatan_saksi1);
        formData.append("des_kel_saksi1", this.form.des_kel_saksi1);
        formData.append("alamat_saksi1", this.form.alamat_saksi1);

        formData.append("nik_saksi2", this.form.nik_saksi2);
        formData.append("nama_saksi2", this.form.nama_saksi2);
        formData.append("umur_saksi2", this.form.umur_saksi2);
        formData.append("pekerjaan_saksi2", this.form.pekerjaan_saksi2);
        formData.append("provinsi_saksi2", this.form.provinsi_saksi2);
        formData.append("kabupaten_saksi2", this.form.kabupaten_saksi2);
        formData.append("kecamatan_saksi2", this.form.kecamatan_saksi2);
        formData.append("des_kel_saksi2", this.form.des_kel_saksi2);
        formData.append("alamat_saksi2", this.form.alamat_saksi2);


        formData.append("keterangan_deskel", this.form.keterangan_deskel);
        formData.append("keterangan_kecamatan", this.form.keterangan_kecamatan);
        formData.append("keterangan_kabupaten", this.form.keterangan_kabupaten);
        
        formData.append("status", this.form.status);
        formData.append("keterangan", this.form.keterangan);

        formData.append("createdAt", UMUM.NOW()); 

        formData.append("emailPemohon", this.form.emailPemohon);

        formData.append("file_lampiran", this.form.file_lampiran);


        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            }, 
            body: formData 
        }).then(res_data => { 
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil')
            this.getView();
            // console.log(res_data);
        });
        
      },
      editData : function(){

        this.$store.state.modal_loading = true;


        var formData = new FormData()

        formData.append("id", this.form.id)

        formData.append("m_provinsi", this.form.m_provinsi)
        formData.append("m_kabupaten", this.form.m_kabupaten)
        formData.append("m_kecamatan", this.form.m_kecamatan)
        formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan);

        formData.append("nama_kepala_keluarga", this.form.nama_kepala_keluarga)
        formData.append("no_kk", this.form.no_kk)
        formData.append("nama_bayi", this.form.nama_bayi)
        formData.append("jenis_kelamin_bayi", this.form.jenis_kelamin_bayi)

        formData.append("tempat_kelahiran_bayi", this.form.tempat_kelahiran_bayi)

        formData.append("tmpt_lahir_bayi", this.form.tmpt_lahir_bayi)
        formData.append("tmpt_lahir_bayi_lainnya", this.form.tmpt_lahir_bayi_lainnya)
        formData.append("nama_hari", this.form.nama_hari)
        formData.append("tgl_lahir_bayi", this.form.tgl_lahir_bayi)
        formData.append("pukul", this.form.pukul)
        formData.append("jenis_lahir", this.form.jenis_lahir)
        formData.append("jenis_lahir_lainnya", this.form.jenis_lahir_lainnya)
        formData.append("kelahiran_ke", this.form.kelahiran_ke)
        formData.append("penolong_kelahiran", this.form.penolong_kelahiran)
        formData.append("penolong_kelahiran_lainnya", this.form.penolong_kelahiran_lainnya)
        formData.append("berat_bayi", this.form.berat_bayi)
        formData.append("panjang_bayi", this.form.panjang_bayi)

        formData.append("nik_ibu", this.form.nik_ibu)
        formData.append("nama_ibu", this.form.nama_ibu)
        formData.append("tgl_lahir_ibu", this.form.tgl_lahir_ibu)
        formData.append("pekerjaan_ibu", this.form.pekerjaan_ibu)
        formData.append("provinsi_ibu", this.form.provinsi_ibu)
        formData.append("kabupaten_ibu", this.form.kabupaten_ibu)
        formData.append("kecamatan_ibu", this.form.kecamatan_ibu)
        formData.append("des_kel_ibu", this.form.des_kel_ibu)
        formData.append("alamat_ibu", this.form.alamat_ibu)
        formData.append("kewarganegaraan_ibu", this.form.kewarganegaraan_ibu)
        formData.append("kewarganegaraan_ibu_lainnya", this.form.kewarganegaraan_ibu_lainnya)
        formData.append("tgl_catatan_perkawinan", this.form.tgl_catatan_perkawinan)

        formData.append("nik_ayah", this.form.nik_ayah)
        formData.append("nama_ayah", this.form.nama_ayah)
        formData.append("tgl_lahir_ayah", this.form.tgl_lahir_ayah)
        formData.append("pekerjaan_ayah", this.form.pekerjaan_ayah)
        formData.append("provinsi_ayah", this.form.provinsi_ayah)
        formData.append("kabupaten_ayah", this.form.kabupaten_ayah)
        formData.append("kecamatan_ayah", this.form.kecamatan_ayah)
        formData.append("des_kel_ayah", this.form.des_kel_ayah)
        formData.append("alamat_ayah", this.form.alamat_ayah)
        formData.append("kewarganegaraan_ayah", this.form.kewarganegaraan_ayah)
        formData.append("kewarganegaraan_ayah_lainnya", this.form.kewarganegaraan_ayah_lainnya)

        formData.append("nik_pelapor", this.form.nik_pelapor)
        formData.append("nama_pelapor", this.form.nama_pelapor)
        formData.append("umur_pelapor", this.form.umur_pelapor)
        formData.append("pekerjaan_pelapor", this.form.pekerjaan_pelapor)
        formData.append("provinsi_pelapor", this.form.provinsi_pelapor)
        formData.append("kabupaten_pelapor", this.form.kabupaten_pelapor)
        formData.append("kecamatan_pelapor", this.form.kecamatan_pelapor)
        formData.append("des_kel_pelapor", this.form.des_kel_pelapor)
        formData.append("alamat_pelapor", this.form.alamat_pelapor)

        formData.append("nik_saksi1", this.form.nik_saksi1)
        formData.append("nama_saksi1", this.form.nama_saksi1)
        formData.append("umur_saksi1", this.form.umur_saksi1)
        formData.append("pekerjaan_saksi1", this.form.pekerjaan_saksi1)
        formData.append("provinsi_saksi1", this.form.provinsi_saksi1)
        formData.append("kabupaten_saksi1", this.form.kabupaten_saksi1)
        formData.append("kecamatan_saksi1", this.form.kecamatan_saksi1)
        formData.append("des_kel_saksi1", this.form.des_kel_saksi1)
        formData.append("alamat_saksi1", this.form.alamat_saksi1)

        formData.append("nik_saksi2", this.form.nik_saksi2)
        formData.append("nama_saksi2", this.form.nama_saksi2)
        formData.append("umur_saksi2", this.form.umur_saksi2)
        formData.append("pekerjaan_saksi2", this.form.pekerjaan_saksi2)
        formData.append("provinsi_saksi2", this.form.provinsi_saksi2)
        formData.append("kabupaten_saksi2", this.form.kabupaten_saksi2)
        formData.append("kecamatan_saksi2", this.form.kecamatan_saksi2)
        formData.append("des_kel_saksi2", this.form.des_kel_saksi2)
        formData.append("alamat_saksi2", this.form.alamat_saksi2)

        formData.append("status", this.form.status)
        formData.append("keterangan", this.form.keterangan)
        formData.append("status_deskel", this.form.status_deskel)
        formData.append("status_kecamatan", this.form.status_kecamatan)
        formData.append("status_kabupaten", this.form.status_kabupaten)
        formData.append("file_lampiran", this.form.file_lampiran)

        formData.append("fileOld", this.fileOld);


        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getView();
        });
      },      
      selectData : function(data){  
        // var a = data.m_provinsi_ibux.uraian
        console.log(data);

          this.form.id = data.permohonan_KELAHIRAN.id;

          this.form.modul                         = data.permohonan_KELAHIRAN.modul;
          this.form.m_provinsi                    = data.permohonan_KELAHIRAN.m_provinsi;
          this.form.m_kabupaten                   = data.permohonan_KELAHIRAN.m_kabupaten;
          this.form.m_kecamatan                   = data.permohonan_KELAHIRAN.m_kecamatan;
          this.form.m_desa_kelurahan              = data.permohonan_KELAHIRAN.m_desa_kelurahan;
          this.form.nama_kepala_keluarga          = data.permohonan_KELAHIRAN.nama_kepala_keluarga;
          this.form.no_kk                         = data.permohonan_KELAHIRAN.no_kk;

          this.form.nama_bayi                     = data.permohonan_KELAHIRAN.nama_bayi;
          this.form.jenis_kelamin_bayi            = data.permohonan_KELAHIRAN.jenis_kelamin_bayi;
          this.form.tmpt_lahir_bayi               = data.permohonan_KELAHIRAN.tmpt_lahir_bayi;
          this.form.tmpt_lahir_bayi_lainnya       = data.permohonan_KELAHIRAN.tmpt_lahir_bayi_lainnya;
          this.form.tempat_kelahiran_bayi         = data.permohonan_KELAHIRAN.tempat_kelahiran_bayi;
          this.form.nama_hari                     = data.permohonan_KELAHIRAN.nama_hari;
          this.form.tgl_lahir_bayi                = data.permohonan_KELAHIRAN.tgl_lahir_bayi;
          this.form.pukul                         = data.permohonan_KELAHIRAN.pukul;
          this.form.jenis_lahir                   = data.permohonan_KELAHIRAN.jenis_lahir;
          this.form.jenis_lahir_lainnya           = data.permohonan_KELAHIRAN.jenis_lahir_lainnya;
          this.form.kelahiran_ke                  = data.permohonan_KELAHIRAN.kelahiran_ke;
          this.form.penolong_kelahiran            = data.permohonan_KELAHIRAN.penolong_kelahiran;
          this.form.penolong_kelahiran_lainnya    = data.permohonan_KELAHIRAN.penolong_kelahiran_lainnya;
          this.form.berat_bayi                    = data.permohonan_KELAHIRAN.berat_bayi;
          this.form.panjang_bayi                  = data.permohonan_KELAHIRAN.panjang_bayi;

          this.form.nik_ibu                       = data.permohonan_KELAHIRAN.nik_ibu;
          this.form.nama_ibu                      = data.permohonan_KELAHIRAN.nama_ibu;
          this.form.tgl_lahir_ibu                 = data.permohonan_KELAHIRAN.tgl_lahir_ibu;
          this.form.pekerjaan_ibu                 = data.permohonan_KELAHIRAN.pekerjaan_ibu;
          this.form.provinsi_ibu                  = data.permohonan_KELAHIRAN.provinsi_ibu;
          this.form.kabupaten_ibu                 = data.permohonan_KELAHIRAN.kabupaten_ibu;
          this.form.kecamatan_ibu                 = data.permohonan_KELAHIRAN.kecamatan_ibu;
          this.form.des_kel_ibu                   = data.permohonan_KELAHIRAN.des_kel_ibu;
          this.form.alamat_ibu                    = data.permohonan_KELAHIRAN.alamat_ibu;
          this.form.kewarganegaraan_ibu           = data.permohonan_KELAHIRAN.kewarganegaraan_ibu;
          this.form.kewarganegaraan_ibu_lainnya   = data.permohonan_KELAHIRAN.kewarganegaraan_ibu_lainnya;
          this.form.tgl_catatan_perkawinan        = data.permohonan_KELAHIRAN.tgl_catatan_perkawinan;

          this.form.nik_ayah                      = data.permohonan_KELAHIRAN.nik_ayah;
          this.form.nama_ayah                     = data.permohonan_KELAHIRAN.nama_ayah;
          this.form.tgl_lahir_ayah                = data.permohonan_KELAHIRAN.tgl_lahir_ayah;
          this.form.pekerjaan_ayah                = data.permohonan_KELAHIRAN.pekerjaan_ayah;
          this.form.provinsi_ayah                 = data.permohonan_KELAHIRAN.provinsi_ayah;
          this.form.kabupaten_ayah                = data.permohonan_KELAHIRAN.kabupaten_ayah;
          this.form.kecamatan_ayah                = data.permohonan_KELAHIRAN.kecamatan_ayah;
          this.form.des_kel_ayah                  = data.permohonan_KELAHIRAN.des_kel_ayah;
          this.form.alamat_ayah                   = data.permohonan_KELAHIRAN.alamat_ayah;
          this.form.kewarganegaraan_ayah          = data.permohonan_KELAHIRAN.kewarganegaraan_ayah;
          this.form.kewarganegaraan_ayah_lainnya  = data.permohonan_KELAHIRAN.kewarganegaraan_ayah_lainnya;

          this.form.nik_pelapor         = data.permohonan_KELAHIRAN.nik_pelapor;
          this.form.nama_pelapor        = data.permohonan_KELAHIRAN.nama_pelapor;
          this.form.umur_pelapor        = data.permohonan_KELAHIRAN.umur_pelapor;
          this.form.pekerjaan_pelapor   = data.permohonan_KELAHIRAN.pekerjaan_pelapor;
          this.form.provinsi_pelapor    = data.permohonan_KELAHIRAN.provinsi_pelapor;
          this.form.kabupaten_pelapor   = data.permohonan_KELAHIRAN.kabupaten_pelapor;
          this.form.kecamatan_pelapor   = data.permohonan_KELAHIRAN.kecamatan_pelapor;
          this.form.des_kel_pelapor     = data.permohonan_KELAHIRAN.des_kel_pelapor;
          this.form.alamat_pelapor      = data.permohonan_KELAHIRAN.alamat_pelapor;

          this.form.nik_saksi1            = data.permohonan_KELAHIRAN.nik_saksi1;
          this.form.nama_saksi1           = data.permohonan_KELAHIRAN.nama_saksi1;
          this.form.umur_saksi1           = data.permohonan_KELAHIRAN.umur_saksi1;
          this.form.pekerjaan_saksi1      = data.permohonan_KELAHIRAN.pekerjaan_saksi1;
          this.form.provinsi_saksi1       = data.permohonan_KELAHIRAN.provinsi_saksi1;
          this.form.kabupaten_saksi1      = data.permohonan_KELAHIRAN.kabupaten_saksi1;
          this.form.kecamatan_saksi1      = data.permohonan_KELAHIRAN.kecamatan_saksi1;
          this.form.des_kel_saksi1        = data.permohonan_KELAHIRAN.des_kel_saksi1;
          this.form.alamat_saksi1         = data.permohonan_KELAHIRAN.alamat_saksi1;

          this.form.nik_saksi2            = data.permohonan_KELAHIRAN.nik_saksi2;
          this.form.nama_saksi2           = data.permohonan_KELAHIRAN.nama_saksi2;
          this.form.umur_saksi2           = data.permohonan_KELAHIRAN.umur_saksi2;
          this.form.pekerjaan_saksi2      = data.permohonan_KELAHIRAN.pekerjaan_saksi2;
          this.form.provinsi_saksi2       = data.permohonan_KELAHIRAN.provinsi_saksi2;
          this.form.kabupaten_saksi2      = data.permohonan_KELAHIRAN.kabupaten_saksi2;
          this.form.kecamatan_saksi2      = data.permohonan_KELAHIRAN.kecamatan_saksi2;
          this.form.des_kel_saksi2        = data.permohonan_KELAHIRAN.des_kel_saksi2;
          this.form.alamat_saksi2         = data.permohonan_KELAHIRAN.alamat_saksi2;

          this.form.status                = data.permohonan_KELAHIRAN.status
          this.form.keterangan            = data.permohonan_KELAHIRAN.keterangan
          this.form.keterangan_deskel     = data.permohonan_KELAHIRAN.keterangan_deskel
          this.form.keterangan_kecamatan  = data.permohonan_KELAHIRAN.keterangan_kecamatan
          this.form.keterangan_kabupaten  = data.permohonan_KELAHIRAN.keterangan_kabupaten
          this.form.status_deskel         = data.permohonan_KELAHIRAN.status_deskel
          this.form.status_kecamatan      = data.permohonan_KELAHIRAN.status_kecamatan
          this.form.status_kabupaten      = data.permohonan_KELAHIRAN.status_kabupaten
          this.form.createdAt_deskel      = data.permohonan_KELAHIRAN.createdAt_deskel
          this.form.createdAt_kecamatan   = data.permohonan_KELAHIRAN.createdAt_kecamatan
          this.form.createdAt_kabupaten   = data.permohonan_KELAHIRAN.createdAt_kabupaten

          this.form.createdBy             = data.permohonan_KELAHIRAN.createdBy
 
          this.form.file_lampiran         = data.permohonan_KELAHIRAN.file_lampiran
          this.form.file_lampiranOld      = data.permohonan_KELAHIRAN.file_lampiranOld

          this.form.emailPemohon          = data.permohonan_KELAHIRAN.emailPemohon; 

          // this.form.email_file    = data.permohonan_KTP.email_file;
          this.form.email_fileOld = data.permohonan_KELAHIRAN.email_file;
          this.form.email_from    = this.form.email_from;
          this.form.email_to      = this.form.emailPemohon;
          this.form.email_subject = data.permohonan_KELAHIRAN.email_subject;
          this.form.email_html    = data.permohonan_KELAHIRAN.email_html;
          
          this.fileOld            = data.permohonan_KELAHIRAN.file;
          this.fileOldThumb       = data.permohonan_KELAHIRAN.fileThumb;
          
        this.wilayah = {
          uraian_provinsi : data.m_provinsi.uraian,
          kd_provinsi : data.m_provinsi.kd_provinsi,
          uraian_kabupaten : data.m_kabupaten.uraian,
          kd_kabupaten : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan : data.m_kecamatan.uraian,
          kd_kecamatan : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
        };
        this.wilayahIbu = {
          uraian_provinsi       : data.wilayah_provinsi_ibu.uraian,
          kd_provinsi           : data.wilayah_provinsi_ibu.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_ibu.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_ibu.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_ibu.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_ibu.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_ibu.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_ibu.kd_desa_kelurahan,
        };
        this.wilayahAyah = {
          uraian_provinsi       : data.wilayah_provinsi_ayah.uraian,
          kd_provinsi           : data.wilayah_provinsi_ayah.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_ayah.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_ayah.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_ayah.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_ayah.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_ayah.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_ayah.kd_desa_kelurahan,
        };
        this.wilayahPelapor = {
          uraian_provinsi       : data.wilayah_provinsi_pelapor.uraian,
          kd_provinsi           : data.wilayah_provinsi_pelapor.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_pelapor.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_pelapor.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_pelapor.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_pelapor.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_pelapor.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_pelapor.kd_desa_kelurahan,
        };
        this.wilayahSaksi1 = {
          uraian_provinsi       : data.wilayah_provinsi_saksi1.uraian,
          kd_provinsi           : data.wilayah_provinsi_saksi1.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_saksi1.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_saksi1.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_saksi1.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_saksi1.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_saksi1.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_saksi1.kd_desa_kelurahan,
        };
        this.wilayahSaksi2 = {
          uraian_provinsi       : data.wilayah_provinsi_saksi2.uraian,
          kd_provinsi           : data.wilayah_provinsi_saksi2.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_saksi2.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_saksi2.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_saksi2.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_saksi2.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_saksi2.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_saksi2.kd_desa_kelurahan,
        };
        // console.log(data.wilayah_provinsi_ibu.uraian);
        

      },
      removeData : function(E){
        this.$store.state.modal_loading = true;

        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                fileOld : this.fileOld,
                file_lampiran     : this.form.file_lampiran,
                file_lampiranOld  : this.form.file_lampiranOld,
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        }); 
      },
      clearData:function(){

              this.form.id                           = ''
              this.form.modul                        = 'sk_kelahiran'
              this.form.m_provinsi                   = '74'
              this.form.m_kabupaten                  = '7405'
              this.form.m_kecamatan                  = ''
              this.form.m_desa_kelurahan             = ''
              this.form.nama_kepala_keluarga         = ''
              this.form.no_kk                        = ''
              this.form.nama_bayi                    = ''
              this.form.jenis_kelamin_bayi           = ''
              this.form.tmpt_lahir_bayi              = ''
              this.form.tmpt_lahir_bayi_lainnya      = ''
              this.form.tempat_kelahiran_bayi        = ''
              this.form.nama_hari                    = ''
              this.form.tgl_lahir_bayi               = ''
              this.form.pukul                        = ''
              this.form.jenis_lahir                  = ''
              this.form.jenis_lahir_lainnya          = ''
              this.form.kelahiran_ke                 = ''
              this.form.penolong_kelahiran           = ''
              this.form.penolong_kelahiran_lainnya   = ''
              this.form.berat_bayi                   = ''
              this.form.panjang_bayi                 = ''
              this.form.nik_ibu                      = ''
              this.form.nama_ibu                     = ''
              this.form.tgl_lahir_ibu                = ''
              this.form.pekerjaan_ibu                = ''
              this.form.provinsi_ibu                 = ''
              this.form.kabupaten_ibu                = ''
              this.form.kecamatan_ibu                = ''
              this.form.des_kel_ibu                  = ''
              this.form.alamat_ibu                   = ''
              this.form.kewarganegaraan_ibu          = ''
              this.form.kewarganegaraan_ibu_lainnya  = ''
              this.form.tgl_catatan_perkawinan       = ''
              this.form.nik_ayah                     = ''
              this.form.nama_ayah                    = ''
              this.form.tgl_lahir_ayah               = ''
              this.form.pekerjaan_ayah               = ''
              this.form.provinsi_ayah                = ''
              this.form.kabupaten_ayah               = ''
              this.form.kecamatan_ayah               = ''
              this.form.des_kel_ayah                 = ''
              this.form.alamat_ayah                  = ''
              this.form.kewarganegaraan_ayah         = ''
              this.form.kewarganegaraan_ayah_lainnya = ''
              this.form.nik_pelapor                  = ''
              this.form.nama_pelapor                 = ''
              this.form.umur_pelapor                 = ''
              this.form.pekerjaan_pelapor            = ''
              this.form.provinsi_pelapor             = ''
              this.form.kabupaten_pelapor            = ''
              this.form.kecamatan_pelapor            = ''
              this.form.des_kel_pelapor              = ''
              this.form.alamat_pelapor               = ''
              this.form.nik_saksi1                   = ''
              this.form.nama_saksi1                  = ''
              this.form.umur_saksi1                  = ''
              this.form.pekerjaan_saksi1             = ''
              this.form.provinsi_saksi1              = ''
              this.form.kabupaten_saksi1             = ''
              this.form.kecamatan_saksi1             = ''
              this.form.des_kel_saksi1               = ''
              this.form.alamat_saksi1                = ''
              this.form.nik_saksi2                   = ''
              this.form.nama_saksi2                  = ''
              this.form.umur_saksi2                  = ''
              this.form.pekerjaan_saksi2             = ''
              this.form.provinsi_saksi2              = ''
              this.form.kabupaten_saksi2             = ''
              this.form.kecamatan_saksi2             = ''
              this.form.des_kel_saksi2               = ''
              this.form.alamat_saksi2                = ''
              this.form.keterangan_deskel            = ''
              this.form.keterangan_kecamatan         = ''
              this.form.keterangan_kabupaten         = ''
              this.form.status                       = 0
              this.form.keterangan                   = 0
              this.form.keterangan_deskel            = ''
              this.form.keterangan_kecamatan         = ''
              this.form.keterangan_kabupaten         = ''
              this.form.status_deskel                = 0
              this.form.status_kecamatan             = 0
              this.form.status_kabupaten             = 0
              this.form.createdAt_deskel             = ''
              this.form.createdAt_kecamatan          = ''
              this.form.createdAt_kabupaten          = ''
              this.form.file_terbitan                = null 

              this.form.file_lampiran                = null
              this.form.file_lampiranOld             = null

              this.form.emailPemohon                 = ''
              this.form.email_file                   = null
              this.form.email_fileOld                = ''
              this.form.email_from                   = ''
              this.form.email_to                     = ''
              this.form.email_subject                = ''
              this.form.email_html                   = '' 

              this.wilayah                           = ''
              this.wilayahIbu                        = ''
              this.wilayahAyah                       = ''
              this.wilayahPelapor                    = ''
              this.wilayahSaksi1                     = ''
              this.wilayahSaksi2                     = ''
      },

    // ============================= USERS =============================

    // ============================= KECAMATAN =============================
      getViewKecamatan : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "viewKecamatan", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kecamatan : this.form.status_kecamatan,
                pl_provinsi       :this.$store.state.lcProfile.provinsi,
                pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data_kecamatan = res_data.data;
                this.page_last = res_data.jmlData; 
                // console.log("INI KECAMATAN")
                console.log(res_data);
        });
      },

      editDataKecamatan : function(status){
        this.$store.state.modal_loading = true;

        // console.log(status)
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "editDataKecamatan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kecamatan : this.form.keterangan_kecamatan,
              createdAt_kecamatan : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKecamatan();
        });
      },

    // ============================= KECAMATAN =============================

    // ============================= KABUPATEN =============================
      getViewKabupaten : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "viewKabupaten", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kabupaten : this.form.status_kabupaten
            })
          })
            .then(res => res.json())
            .then(res_data => {
              // console.log("TAAAAAAAAAAIIIIIIII")
                this.list_data_kabupaten = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
      editDataKabupaten : function(status){
        this.$store.state.modal_loading = true;

        console.log("SA DI CLICK")
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "editDataKabupaten", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kabupaten : this.form.keterangan_kabupaten,
              createdAt_kabupaten : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKabupaten();
        });
      },

      terbit_file_Kabupaten : function(){
        this.$store.state.modal_loading = true;

        console.log(this.form.email_fileOld);
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("email_file", this.form.email_file); 
        formData.append("email_fileOld", this.form.email_fileOld); 
        formData.append("email_from", this.form.email_from)
        formData.append("email_to", this.form.email_to)
        formData.append("email_subject", this.form.email_subject) 
        formData.append("email_html", this.form.email_html)
        

        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN + "file_terbitan_Kabupaten", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData,
        }).then(res_data => { 
            this.wa_notif()
            this.$store.state.modal_loading = false; 
            this.$store.commit('notif_terbit');
            this.getView();
        });
      },

      async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Surat Keterangan Kelahiran (WNI)'
          }))
          console.log(data);
      },
    // ============================= KABUPATEN =============================
      bukaTab(linknya){
        window.open(linknya);
      },
    // ====================================== filter autocomplete ======================================
        renderChildProv(data) {
            return `
            <span><b>${data.kd_provinsi}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKab(data) {
            return `
            <span><b>${data.kd_kabupaten}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKec(data) {
            return `
            <span><b>${data.kd_kecamatan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChild_des_kel(data) {
            return `
            <span><b>${data.kd_desa_kelurahan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        get_auto(data){ 
          this.form.m_provinsi = data.m_provinsi  
        },

        get_auto_kab(data){ 
          this.form.m_kabupaten = data.m_kabupaten  
        },

        get_auto_kec(data){ 
          this.form.m_kecamatan = data.m_kecamatan  
        },

        get_auto_des_kel(data){ 
          this.form.m_desa_kelurahan = data.m_desa_kelurahan 
        },        
 
        prov_ibu(data){  
          this.form.provinsi_ibu = data.m_provinsi  
        }, 
        kab_ibu(data){ 
          this.form.kabupaten_ibu = data.m_kabupaten 
        }, 
        kec_ibu(data){ 
          this.form.kecamatan_ibu = data.m_kecamatan  
        }, 
        des_kel_ibu(data){ 
          this.form.des_kel_ibu = data.m_desa_kelurahan  
        },    

        prov_ayah(data){ 
          this.form.provinsi_ayah = data.m_provinsi  
        },
        kab_ayah(data){ 
          this.form.kabupaten_ayah = data.m_kabupaten 
        },
        kec_ayah(data){ 
          this.form.kecamatan_ayah = data.m_kecamatan  
        },
        des_kel_ayah(data){ 
          this.form.des_kel_ayah = data.m_desa_kelurahan  
        },

        prov_pelapor(data){ 
          this.form.provinsi_pelapor = data.m_provinsi  
        }, 
        kab_pelapor(data){ 
          this.form.kabupaten_pelapor = data.m_kabupaten 
        },
        kec_pelapor(data){ 
          this.form.kecamatan_pelapor = data.m_kecamatan  
        },
        des_kel_pelapor(data){ 
          this.form.des_kel_pelapor = data.m_desa_kelurahan  
        },

        prov_saksi1(data){ 
          this.form.provinsi_saksi1 = data.m_provinsi  
        },
        kab_saksi1(data){ 
          this.form.kabupaten_saksi1 = data.m_kabupaten 
        },
        kec_saksi1(data){ 
          this.form.kecamatan_saksi1 = data.m_kecamatan  
        },
        des_kel_saksi1(data){ 
          this.form.des_kel_saksi1 = data.m_desa_kelurahan  
        },

        prov_saksi2(data){ 
          this.form.provinsi_saksi2 = data.m_provinsi  
        },
        kab_saksi2(data){ 
          this.form.kabupaten_saksi2 = data.m_kabupaten 
        },
        kec_saksi2(data){ 
          this.form.kecamatan_saksi2 = data.m_kecamatan  
        },
        des_kel_saksi2(data){ 
          this.form.des_kel_saksi2 = data.m_desa_kelurahan  
        },
    // ====================================== filter autocomplete ======================================
      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
        return `${filesNumber} files of ${maxFiles} | ${totalSize}`
      },

      CariData(){
        
        if (this.$store.state.lcProfile.kelas         == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas  == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },

      

      cekButton_status_kecamatan: function(data){  
          var a = data.permohonan_KELAHIRAN.status 
          var status_kab = data.permohonan_KELAHIRAN.status_kabupaten  
          if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
            if (status_kab == 1) {
              return true
            }
            return false
          }else{
            if (a == 1) {
              return true
            }else{
              return false
            }
          }  
        },
 
    

 
    

    },
    mounted(){ 
      this.getView()  
      this.CariData()  

      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from
      // console.log(email_from);

      this.$store.state.lcProfile.kelas
    }
}
